import { observable, action, intercept } from "mobx";
import { post } from "../services/ajax.service";

class SpecialtyCarveOutStore {
  @observable not_found = false;
  @observable participants = [];
  @observable top_five_participants = [];
  @observable drugs = [];
  @observable GPI = [];
  @observable total_pgx_participants = 0;
  @observable drug_count = 0;
  @observable unique_par = 0;
  @observable total_cost = 0;
  @observable url = "/api/v1/recommendationactions/SpecialtyCarveOut";
  constructor() {
    intercept(this, change => {
      if (change.newValue == null || change.newValue == 0) {
        localStorage.setItem("not_found", true)
      } else if (change.newValue != null || change.newValue != 0) {
        localStorage.setItem("not_found", false)
      }
      return change;
    })
  }
  @action getParticipants = async (data) => {
    this.partiticpants = [];
    try {
      let response = await post(
        `${this.url}/getParticipants`,
        data
      );

      this.participants = response.data;
    } catch (err) {
      console.log(err);
    }
  }
  @action Get_Specialty_Carve_Out_Participants = async (data) => {
    this.top_five_participants = [];
    try {
      let response = await post(
        `${this.url}/Get_Specialty_Carve_Out_Participants`,
        data
      );

      this.top_five_participants = response.data;
    } catch (err) {
      console.log(err);
    }
  }

  @action getTotalCost = async (data) => {
    this.total_cost = 0;;
    try {
      let response = await post(
        `${this.url}/getTotalCost`,
        data
      );

      this.total_cost = response.data[0].claim_cost;
    } catch (err) {
      console.log(err);
    }
  }

  @action getDrugsCount = async (data) => {
    this.drug_count = 0;
    try {
      let response = await post(
        `${this.url}/getDrugsCount`,
        data
      );

      this.drug_count = (new Set(response.data[0].drug_count.replace(/,\s*$/, "").split(",").filter(a => a != ""))).size;
      this.unique_par = (new Set(response.data[0].unique_par.replace(/,\s*$/, "").split(",").filter(a => a != ""))).size;
    } catch (err) {
      console.log(err);
    }
  }

  @action getDrugs = async (data) => {
    this.drugs = [];
    try {
      let response = await post(
        `${this.url}/getDrugs`,
        data
      );

      this.drugs = response.data;
    } catch (err) {
      console.log(err);
    }
  }

  @action getGPI = async (data) => {
    this.GPI = [];
    try {
      let response = await post(
        `${this.url}/getGPI`,
        data
      );

      this.GPI = response.data;
    } catch (err) {
      console.log(err);
    }
  }

  @action getTotalPgxParticipants = async (data) => {
    this.GPI = [];
    try {
      let response = await post(
        `${this.url}/getTotalPgxParticipants`,
        data
      );

      this.total_pgx_participants = (new Set(response.data[0].total_pgx_participants.replace(/,\s*$/, "").split(",").filter(a => a != ""))).size;
    } catch (err) {
      console.log(err);
    }
  }


}

export default SpecialtyCarveOutStore;
